import { render, staticRenderFns } from "./MultipleChoicePreview.vue?vue&type=template&id=a53e0a44&scoped=true&"
import script from "./MultipleChoicePreview.vue?vue&type=script&lang=js&"
export * from "./MultipleChoicePreview.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoicePreview.vue?vue&type=style&index=0&id=a53e0a44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53e0a44",
  null
  
)

export default component.exports